import React from 'react';

import { CompanyPageLinkingStep } from '@bingads-webui-campaign-react/linkedin-company-page-linking';
import { LinkedInAdStep, useLinkedInAdRepository, useAdEditorRepository } from '@bingads-webui-campaign-react/linkedin-ad';
import { LinkedInAdsManagerStep, useLinkedInAdsManagerRepository } from '@bingads-webui-campaign-react/linkedin-ads-manager';
import { TargetingStep, useTargetingStepRepository } from '@bingads-webui-campaign-react/linkedin-targeting';
import { BudgetStep, useBudgetRepository } from '@bingads-webui-campaign-react/linkedin-budget';
import { SummaryStep, useSummaryRepository } from '@bingads-webui-campaign-react/linkedin-summary';
import { LinkedInAdGroupSettings, useLinkedinAdGroupSettingsRepository } from '@bingads-webui-campaign-react/linkedin-adgroup-settings';
import { LinkedInCampaingSettings, useLinkedInCampaignSettingsRepository } from '@bingads-webui-campaign-react/linkedin-campaign-settings';
import { LINKEDIN_WIZARDS, LINKEDIN_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/linkedin-utils';

export const LinkedInStepConfig = [
  {
    id: LINKEDIN_WIZARD_STEP_PATHS.LI_COMPANY_PAGE_LINKING,
    view: CompanyPageLinkingStep,
  },
  {
    id: LINKEDIN_WIZARD_STEP_PATHS.LINKEDIN_AD,
    view: LinkedInAdStep,
    repository: useLinkedInAdRepository,
  },
  {
    id: LINKEDIN_WIZARD_STEP_PATHS.MULTI_AD_MANAGER,
    view: LinkedInAdsManagerStep,
    repository: useLinkedInAdsManagerRepository,
  },
  {
    id: LINKEDIN_WIZARD_STEP_PATHS.TARGETING,
    view: TargetingStep,
    repository: useTargetingStepRepository,
  },
  {
    id: LINKEDIN_WIZARD_STEP_PATHS.BUDGET,
    view: BudgetStep,
    repository: useBudgetRepository,
  },
  {
    id: LINKEDIN_WIZARD_STEP_PATHS.SUMMARY,
    view: SummaryStep,
    repository: useSummaryRepository,
  },
];

export const LinkedInSingleStepConfigs = {
  [LINKEDIN_WIZARDS.CAMPAIGN_SETTINGS]: {
    view: LinkedInCampaingSettings,
    repository: useLinkedInCampaignSettingsRepository,
  },
  [LINKEDIN_WIZARDS.AD_GROUP_SETTINGS]: {
    view: LinkedInAdGroupSettings,
    repository: useLinkedinAdGroupSettingsRepository,
  },
  [LINKEDIN_WIZARDS.AD_EDITOR]: {
    view: props => <LinkedInAdStep isAdEditor {...props} />,
    repository: useAdEditorRepository,
  },
};
